import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { adminLogin } from '@/lib/api';

const AdminLoginPage = () => {
  const [email, setEmail] = useState('admin@thepadeldraw.co.uk');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await adminLogin({ email, password });
      localStorage.setItem('pd_admin_token', r.token);
      toast.success('Signed in as admin');
      nav('/admin/dashboard');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Login failed');
    } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[color:var(--pd-bg)] p-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-surface border border-pd rounded-2xl p-6">
        <div className="font-mono text-[10px] text-muted-sage uppercase">Admin</div>
        <h1 className="font-display text-4xl leading-none mt-2">Sign in</h1>
        <div className="mt-6 space-y-3">
          <input required type="email" value={email} onChange={(e)=>setEmail(e.target.value)} className="w-full h-12 rounded-xl bg-[color:var(--pd-bg)] border border-pd px-4 text-sm" data-testid="admin-login-email-input" />
          <input required type="password" placeholder="Password" value={password} onChange={(e)=>setPassword(e.target.value)} className="w-full h-12 rounded-xl bg-[color:var(--pd-bg)] border border-pd px-4 text-sm" data-testid="admin-login-password-input" />
          <button disabled={loading} className="w-full bg-[color:var(--pd-accent-yellow)] text-[#14251c] rounded-xl px-4 py-3 font-medium disabled:opacity-60" data-testid="admin-login-submit">
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </div>
      </form>
    </div>
  );
};
export default AdminLoginPage;
